import { IUserResponse } from "../types/Auth/IUserResponse.interface";
import { apiClient } from "../utils/apiClient";

export const loginService = async () => {
  return apiClient.get<IUserResponse>("/v1/login");
};
